import {
  Col,
  Container,
  Dropdown,
  FloatingLabel,
  Form,
  InputGroup,
  Placeholder,
  Row,
  Table,
} from "react-bootstrap";
import { HeadPage } from "src/componentes";
import TributacaoMensagemCode from "./TributacaoMensagem.Code";
import { useEffect, useState } from "react";
import { IRoute } from "src/interfaces/IRoute";
import { useNavigate } from "react-router-dom";

const TributacaoMensagemView = () => {
  const [menuItens, setMenuItens] = useState<IRoute[]>([]);
  const navigate = useNavigate();
  const { register, errors, handleSubmit, onSubmit, loading, data } =
    TributacaoMensagemCode();

  useEffect(() => {
    setMenuItens([
      {
        name: "Nova Mensagem...",
        route: "/fiscal/tributacao/mensagem/cadastro",
      },
    ]);
  }, []);

  const handleClickNavigate = (route: string) => () => {
    navigate(route);
  };

  const handleClickAlterar = (id: number) => () => {
    navigate(`/fiscal/tributacao/mensagem/cadastro?id=${id}`);
  };

  return (
    <Container>
      <HeadPage headText="Mensagens">
        {menuItens !== undefined &&
          menuItens.map((item) => (
            <Dropdown.Item
              key={item.name}
              onClick={handleClickNavigate(item.route)}
            >
              {item.name}
            </Dropdown.Item>
          ))}
      </HeadPage>
      <Row>
        <Col>
          <Form noValidate onSubmit={handleSubmit(onSubmit)}>
            <InputGroup hasValidation>
              <FloatingLabel controlId="pesquisar" label="Pesquisar">
                <Form.Control
                  type="text"
                  placeholder="Pesquisar"
                  isInvalid={!!errors.mensagem?.message?.toString()}
                  {...register("mensagem")}
                />
                {errors.mensagem?.message?.toString() && (
                  <Form.Control.Feedback type="invalid">
                    {errors.mensagem?.message?.toString()}
                  </Form.Control.Feedback>
                )}
              </FloatingLabel>
            </InputGroup>
          </Form>
        </Col>
      </Row>
      <Row>
        {!loading ? (
          <>
            <Col>
              {data && data.length > 0 ? (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th className="col-12">Mensagem</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => (
                      <tr
                        key={item.id}
                        onClick={handleClickAlterar(item.id)}
                        style={{ cursor: "pointer" }}
                      >
                        <td className="col-12">{item.mensagem}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <Form.Text>Sem Dados</Form.Text>
              )}
            </Col>
          </>
        ) : (
          <Placeholder as={FloatingLabel} animation="glow">
            <Placeholder xs={12} />
          </Placeholder>
        )}
      </Row>
    </Container>
  );
};

export default TributacaoMensagemView;
